export default __webpack_public_path__ + "static/5.2.20_factor_table_studio_Factor.TA1_.408_09242020-443faf8f21a3ad65480a16a2954900f0.jpg";